import { Component, ViewEncapsulation, ViewChild, TemplateRef, Input, ElementRef, EventEmitter, Output, Renderer2, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { qmsService } from '../qms.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { MsalService } from '@azure/msal-angular';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';

export interface QmsTasksEcInterface {
  qmsTaskECVwPk: {
    ecId: number;
  },
  module: string;
  refNo: number;
  triggeredFromEcId: number;
  checkReqdFor: string;
  owner: number;
  dueDate: Date;
  remindNDaysBeforeDueDate: number;
  methodology: string;
  criteria: string;
  startDate: Date;
  conclusion: string;
  status: string;
  outcome: string;
  closureComments: string;
  createdOn: Date;
  createdBy: number;
  updatedOn: Date;
  updatedBy: number;
  createdByUser: string;
  updatedByUser: string;
  userId: number;
  operation: string;
  deleteReason: string;
}
export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-tasks-ec',
  templateUrl: './tasks-ec.component.html',
  styleUrls: ['./tasks-ec.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class TasksEcComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() activityData: boolean;
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  datepickerDateCustomClasses: DatepickerDateCustomClasses[];
  snackbarRef: any;
  isProcessing = false;
  @Output() valueChange = new EventEmitter<{ taskEcEffectivicecheck: [] }>;
  module: any;
  refNo: any;
  disableEcFields: boolean;
  isAdenabled: boolean = false;

  checkRequiredForTxt: any;
  ownerTxt: any;
  methodologyTxt: any;
  approvedByTxt: any;
  approvedByTxt1: any;
  QAApprovedBy1: any;
  QaapprovedByTxt: any;
  outcomeTxt: any;
  newCheckRequiredForTxt: any;


  ischeckRequiredForOdd: any = null;
  isownerOdd: any = null;
  ismethodologyOdd: any = null;
  isapprovedByOdd: any = null;
  isQAApprovedOdd: any;
  isQaapprovedByOdd: any = null;
  isoutcomeOdd: any = null;
  isnewCheckRequiredForOdd: any = null;
  constructor(public dialog: MatDialog, public appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, private readonly renderer: Renderer2,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef, public qualityService: qmsService, private readonly authService: MsalService) {
    this.module = this.qualityService.moduleName;
    this.refNo = this.message.activityId;
    const now = new Date();
    this.datepickerDateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }
  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };

  dropDownDataForCheckRequiredFor: any = [];
  dropDownDataForOutcome: any = [];
  dropDownDataForMethodology: any = [];
  dropDownDataForDocumentType: any = [];
  dropDownForOwner: any = [];
  dropDownForActionName: any = [];
  showConclusion: boolean;
  loopcall(a: number) {
    if (a == 4) {
      if (this.activityData) {
        this.getcallMethod();
      } else {
        this.openEcDetailsPopup(this.message.taskLevelData, 0);
      }
    }
  }
  number: any = 0;

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y';
    if (this.message.showSwitchUser) {
      this.message.showSwitchUser = true;
    } else {
      this.message.showSwitchUser = false;
    }
    this.appService.getQmsActiveGroupUsers(this.qualityService.selectedActivityGroupId, this.qualityService.moduleName, 'Effectiveness Check Approver').subscribe((data: any) => {

      this.dropDownDataForApprovedBy = data;
      this.selectBoxForApprovedBy();
    });
    this.appService.getQmsActiveGroupUsers(this.qualityService.selectedActivityGroupId, this.qualityService.moduleName, 'QA').subscribe((data: any) => {

      this.dropDownDataForQAApprovedBy = data;
      this.selectBoxForQAApprovedBy();
    });

    this.isProcessing = true;

    const AU: string = this.qualityService.moduleName == 'AU' ? 'AU_' : '';

    this.appService.getCodeListsByGroup(AU + "EFFECTIVENESS_CHECK_FOR").subscribe((data: any) => {
      this.dropDownDataForCheckRequiredFor = data;
      this.number = this.number + 1;
      this.loopcall(this.number);
      this.selectBoxForCheckRequiredFor();
    });

    this.appService.getCodeListsByGroup(AU + "EFFECTIVENESS_CHECK_OUTCOME").subscribe((data: any) => {
      this.dropDownDataForOutcome = data;
      this.number = this.number + 1;
      this.loopcall(this.number);
      this.selectBoxForOutcome();
    });

    this.appService.getCodeListsByGroup(AU + "EFFECTIVENESS_CHECK_METHODOLOGY").subscribe((data: any) => {
      this.dropDownDataForMethodology = data;
      this.number = this.number + 1;
      this.loopcall(this.number);
      this.selectBoxForMethodology();
    });

    this.appService.getCodeListsByGroup("DOCUMENT_TYPE").subscribe((data: any) => {
      this.dropDownDataForDocumentType = data;
      this.number = this.number + 1;
      this.loopcall(this.number);
      this.selectBoxForDocumentType();
    });
    this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Effectiveness Check Performer').subscribe((data: any) => {
      this.dropDownForOwner = data;
      this.selectBoxForOwner();
    });
    this.appService.getQmsGroupDetailsByModule(this.qualityService.selectedGroup, this.qualityService.moduleName).subscribe((data: any) => {
      if (this.ecData.status == 'In Progress' && data?.skipStages == "QA Approval at Effectiveness Check") {
        this.showClosedStatusFields = true;
      }
    });

    this.getcallMethod();
  }

  refreshGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  qmsTasksECDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.qmsTasksECDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.qmsTasksECDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.qmsTasksECDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  selectedApprovedBy: any = null;
  approvedByListDropdown: any = [];
  dropDownDataForApprovedBy: any = [];
  selectBoxForApprovedBy() {
    this.approvedByListDropdown = [];
    for (const element of this.dropDownDataForApprovedBy) {
      this.approvedByListDropdown = this.approvedByListDropdown.concat({
        valueExp: element.userId,
        displayExp: element.userName
      });
    }
  }
  selectedQAApprovedBy: any = null;
  QAapprovedByListDropdown: any = [];
  dropDownDataForQAApprovedBy: any = [];
  selectBoxForQAApprovedBy() {
    this.QAapprovedByListDropdown = [];
    for (const element of this.dropDownDataForQAApprovedBy) {
      this.QAapprovedByListDropdown = this.QAapprovedByListDropdown.concat({
        valueExp: element.userId,
        displayExp: element.userName
      });
    }
  }

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      }, error: (error) => {
        throw error;
      }
    })
    this.isProcessing = false;

  }
  htmlContent: any;


  getcallMethod() {
    this.qmsTasksECDataForGrid = [];
    const data = {

      gridName: "EC",
      groupId: 0
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_TASK_EC_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          refNoFromEffectivenessCheckMaster: this.message.activityId,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.qmsTasksECDataForGrid = response1;
            this.visibleAuditTrail = false;
            this.valueChange.emit({ taskEcEffectivicecheck: this.qmsTasksECDataForGrid });
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              this.labelcall();
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const element of this.qmsTasksECDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    element[dataType.columnName] = element[dataType.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });

            this.message.gridList = this.qmsTasksECDataForGrid;
            this.collectionSize = this.qmsTasksECDataForGrid.length;
            this.totalPages = Math.ceil(this.qmsTasksECDataForGrid.length / this.itemsPerPage);

            this.setAesthetic();
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: this.module,
      gridName: this.reportObj.gridName,
      groupId: this.qualityService.selectedGroup,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        console.log(this.dynamicLabel);
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  disableAllFields: boolean;
  ECPerformer: boolean;
  makeEnableEffectivenessCheckTextArea: boolean;
  getEcFieldDisabledConditions() {
    this.disableAllFields = false;
    if (this.qualityService.activity.status == 'Closed' && (this.qualityService.userRole[0].qmsRoles.includes("Effectiveness Check Performer") || this.qualityService.userRole[0].qmsRoles.includes("Owner"))) {
      this.ECPerformer = true;
    } else {
      this.ECPerformer = false;
    }

    if (this.ecData.status == 'Pending Approval' || this.ecData.status == 'In Progress' || this.ecData.status == 'Closed' || this.ecData.status == 'Pending QA Approval' ||
      this.ecData.status == 'QA Approval Rejected' || this.ecData.status == 'QA Approved') {
      this.disableEcFields = true;
      this.makeEnableEffectivenessCheckTextArea = true;
    } else if (this.qualityService.userRole[0].qmsRoles.includes("Effectiveness Check Performer")) {
      this.disableEcFields = false;
    } else {
      this.disableEcFields = true;
    }

    if ((this.ecData.status == 'QA Approval Rejected' || this.ecData.status == 'In Progress') && this.qualityService.userRole[0].qmsRoles.includes("Effectiveness Check Performer")) {
      this.makeEnableEffectivenessCheckTextArea = false;
      this.disableAllFields = true;
      this.showConclusion = true;
    }

  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.qmsTasksECDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.qmsTasksECDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.qmsTasksECDataForGrid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.qmsTasksECDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.qmsTasksECDataForGrid[this.previousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.EC_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.qmsTasksECDataForGrid.some((list: any) => list.childCheckBoxs);
    this.previousSelectedValue = idx;
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }


  selectedNewCheckRequiredFor: any = null;
  selectedNewOwner: any = null;

  selectedCheckRequiredFor: any = null;
  selectedCheckRequiredForDisplayExp: any = [];
  selectedCheckRequiredForValueExp: any = [];
  checkRequiredForListDropdown: any = [];

  selectBoxForCheckRequiredFor() {
    const x = this.dropDownDataForCheckRequiredFor.filter((y: any) => {
      if (!this.qualityService.activity.actionItemsReqd &&
        y.codelistName === 'Individual Action Items') {
        return false;
      }

      if (!this.qualityService.activity.preActionItemsReqd &&
        y.codelistName === 'Individual Preliminary Actions') {
        return false;
      }

      return true;
    });
    this.checkRequiredForListDropdown = x?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }))
  }

  selectedOutcome: any = null;
  outcomeListDropdown: any = [];
  selectBoxForOutcome() {
    this.outcomeListDropdown = [];
    for (const element of this.dropDownDataForOutcome) {
      this.outcomeListDropdown = this.outcomeListDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  selectedMethodology: any = null;
  methodologyListDropdown: any = [];
  selectBoxForMethodology() {
    this.methodologyListDropdown = [];
    for (const element of this.dropDownDataForMethodology) {
      this.methodologyListDropdown = this.methodologyListDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  selectedOwner: any = null;
  ownerListDropdown: any = [];
  selectBoxForOwner() {
    this.ownerListDropdown = [];
    for (const element of this.dropDownForOwner) {
      this.ownerListDropdown = this.ownerListDropdown.concat({
        valueExp: element.userId,
        displayExp: element.userName
      });
    }
  }

  onCheckRequiredForSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedCheckRequiredForValueExp = item.valueExp;
        this.message.ecMasterDetails.CHECK_REQD_FOR = item.displayExp;
        if (this.selectedCheckRequiredForValueExp == 'Individual Action Items') {
          this.onTabChangeCheckRequiredFor = "Individual Action Items";
          this.selectedTab = 'Actions';
          this.onTabChanged(this.selectedTab);
        } else if (this.selectedCheckRequiredForValueExp == 'Individual Findings') {
          this.onTabChangeCheckRequiredFor = this.selectedCheckRequiredForValueExp;
          this.selectedTab = 'Findings';
          this.onTabChanged(this.selectedTab);
        } else {
          this.onTabChangeCheckRequiredFor = "Over All";
        }

        if (this.checkRequiredForRequiredMsg != undefined) {
          this.checkRequiredForRequiredMsg.style.color = '';
        }
      }
    }
  }

  onCheckRequiredForRemoved(event: any) {
    if (event.isUserInput) {
      this.selectedCheckRequiredForValueExp = null;
      if (this.checkRequiredForRequiredMsg != undefined) {
        this.checkRequiredForRequiredMsg.style.color = 'red';
      }
    }
  }

  onMethodologySelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.methodologyValue != undefined) {
          this.methodologyValue.style.color = '';
        }
      }
    }
  }

  onMethodologyRemoved(item: any) {
    if (this.methodologyValue != undefined) {
      this.methodologyValue.style.color = 'red';
    }
  }

  onOwnerSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.ownerFieldRequiredMsg != undefined) {
          this.ownerFieldRequiredMsg.style.color = '';
        }
        if (this.outcomeValue == 'Set New Check Date') {
          if (this.ownerFieldFieldValue != undefined) {
            this.ownerFieldFieldValue.style.color = '';
          }
        }
      }
    }
  }

  onOwnerRemoved(item: any) {
    this.ownerFieldFieldValue = document.getElementById('ownerField-validation') as HTMLInputElement;
    if (this.ownerFieldRequiredMsg != undefined) {
      this.ownerFieldRequiredMsg.style.color = 'red';
    }
    if (this.outcomeValue == 'Set New Check Date') {
      if (this.ownerFieldFieldValue != undefined) {
        this.ownerFieldFieldValue.style.color = 'red';
      }
    }
  }

  //outcomeValue:any
  onOutcomeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.outcomeValue = item.valueExp;
        if (this.outcomeRequiredMsg != undefined) {
          this.outcomeRequiredMsg.style.color = '';
        }
        if (this.ecData.status == 'QA Approved') {
          if (this.outcomeFieldValue != undefined) {
            this.outcomeFieldValue.style.color = '';
          }
        }
      }
    }
  }

  onOutcomeRemoved(item: any) {
    if (this.outcomeRequiredMsg != undefined) {
      this.outcomeRequiredMsg.style.color = 'red';
    }
    if (this.ecData.status == 'QA Approved') {
      if (this.outcomeFieldValue != undefined) {
        this.outcomeFieldValue.style.color = 'red';
      }
    }
  }

  onNewCheckRequiredForSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.outcomeValue == 'Set New Check Date') {
          if (this.checkRequiredForFieldValue != undefined) {
            this.checkRequiredForFieldValue.style.color = '';
          }
        }
      }
    }
  };

  onNewCheckRequiredForRemoved(item: any) {
    this.checkRequiredForFieldValue = document.getElementById('checkRequiredFor-validation') as HTMLInputElement;
    if (this.outcomeValue == 'Set New Check Date') {
      if (this.checkRequiredForFieldValue != undefined) {
        this.checkRequiredForFieldValue.style.color = 'red';
      }
    }
  }

  selectedActionName: any = [];
  actionNameListDropdown: any = [];
  selectBoxForActionName() {
    this.actionNameListDropdown = [];
    for (const element of this.dropDownForActionName) {
      this.actionNameListDropdown = this.actionNameListDropdown.concat({
        valueExp: element.actionId,
        displayExp: element.actionName
      });
    }
  }

  selectedActionNameForParticipant: any = [];
  actionNameListForParticipantDropdown: any = [];
  selectBoxForActionNameForParticipant() {
    this.actionNameListForParticipantDropdown = [];
    for (const element of this.dropDownForActionName) {
      this.actionNameListForParticipantDropdown = this.actionNameListForParticipantDropdown.concat({
        valueExp: element.actionId,
        displayExp: element.actionName
      });
    }
  }

  selectedDocumentType: any = [];
  documentTypeListDropdown: any = [];
  selectBoxForDocumentType() {
    this.documentTypeListDropdown = [];
    for (const element of this.dropDownDataForDocumentType) {
      this.documentTypeListDropdown = this.documentTypeListDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  editorConfiguration: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '100px',
    minHeight: '100px',
    maxHeight: '400px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: '',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [['undo', 'redo'],
    ['insertImage',
      'insertVideo',
      'toggleEditorMode']]
  };

  angularEditorTextareaConfig = {
    width: '100%',
    height: 'auto',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '30px' },
  };

  config: EditorConfig = {
    //placeholder: 'Type something...',
    buttons: [],
    // height: '100px',
  };

  editorValue: any;
  textareaEditorTitle: string;

  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  dueDatePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: new Date(),
    adaptivePosition: true
  }

  startDatePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: new Date(),
    adaptivePosition: true
  }
  dateTimePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY HH:mm:ss',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    adaptivePosition: true
  }
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  ecData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addPopup', { static: true }) addPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('ecDetailsPopup', { static: true }) ecDetailsPopup: TemplateRef<any>;
  visibleAddPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleEcDetailsPopup: MatDialogRef<TemplateRef<any>>;

  addPopupConfig = {
    width: '50%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  ecDetailsPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '1px', left: '7%' },
    maxWidth: '89vw',
  };

  visibleAddButton: boolean;

  openAddPopup() {
    this.ecData = {};
    this.ischeckRequiredForOdd = null;
    this.isownerOdd = null;
    this.ismethodologyOdd = null;
    this.isapprovedByOdd = null;
    this.isQAApprovedOdd = null;
    this.isQaapprovedByOdd = null;

    this.visibleAddButton = true;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Effectiveness Check";
    if (this.selectedCheckRequiredFor != null) {
      this.selectedCheckRequiredFor = null;
    }
    if (this.selectedOwner != null) {
      this.selectedOwner = null;
    }
    this.ecData.dueDate = null;
    this.ecData.remindNDaysBeforeDueDate = '';
    this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
  }

  checkRequiredForRequiredMsg: any;
  ownerFieldRequiredMsg: any;
  dueDateRequiredMsg: any;
  fieldValidation() {

    this.checkRequiredForRequiredMsg = document.getElementById('checkRequiredFor-validation') as HTMLInputElement;
    this.ownerFieldRequiredMsg = document.getElementById('ownerField-validation') as HTMLInputElement;
    this.dueDateRequiredMsg = document.getElementById('dueDate-validation') as HTMLInputElement;

    if (this.selectedCheckRequiredFor == null) {
      this.checkRequiredForRequiredMsg.style.color = 'red';
    } else {
      this.checkRequiredForRequiredMsg.style.color = '';
    }

    if (this.selectedOwner == null) {
      this.ownerFieldRequiredMsg.style.color = 'red';
    } else {
      this.ownerFieldRequiredMsg.style.color = '';
    }

    if (this.ecData.dueDate) {
      this.dueDateRequiredMsg.style.color = '';
    } else {
      this.dueDateRequiredMsg.style.color = 'red';
    }
  }

  dueDateOnChanged(items: any) {
    if (items != null || items != undefined) {
      this.dueDateRequiredMsg.style.color = '';
    } else {
      this.dueDateRequiredMsg.style.color = 'red';
    }

    if (this.outcomeValue == 'Set New Check Date') {
      if (items != null || items != undefined) {
        this.dueDateFieldValue.style.color = '';
      } else {
        this.dueDateFieldValue.style.color = 'red';
      }
    }
  }

  onApprovedBySelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.approveByFieldValue != undefined) {
          this.approveByFieldValue.style.color = '';
        }
      }
    }
  }

  onApprovedByRemoved(item: any) {
    this.approveByFieldValue = document.getElementById('approveBy-validation') as HTMLInputElement;
    if (this.approveByFieldValue != undefined) {
      this.approveByFieldValue.style.color = 'red';
    }
  };

  onQaApprovedBySelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.qaApproveByFieldValue != undefined) {
          this.qaApproveByFieldValue.style.color = '';
        }
      }
    };
  }

  onQaApprovedByRemoved(item: any) {
    this.qaApproveByFieldValue = document.getElementById('qaApproveBy-validation') as HTMLInputElement;
    if (this.qaApproveByFieldValue != undefined) {
      this.qaApproveByFieldValue.style.color = 'red';
    }
  };

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  addFunction(ecData: any) {
    if (this.selectedCheckRequiredFor == null || this.selectedOwner == null || this.ecData.dueDate == null) {
      this.fieldValidation();
      alert('Please enter the all mandatory fields...');
    } else {
      this.isProcessing = true;
      ecData.module = this.qualityService.moduleName;
      ecData.refNo = this.message.activityId;
      ecData.remindNDaysBeforeDueDate = this.ecData.remindNDaysBeforeDueDate;
      if (this.selectedCheckRequiredFor) {
        ecData.checkReqdFor = this.selectedCheckRequiredFor;
      } else {
        ecData.checkReqdFor = null;
      }
      if (this.selectedOwner) {
        ecData.owner = this.selectedOwner;
      } else {
        ecData.owner = null;
      }
      if (this.ecData.dueDate == null) {
        ecData.dueDate = null;
      } else {
        const dueDateValue = new Date(this.ecData.dueDate)
        ecData.dueDate = this.appService.dateZoneConvertion(dueDateValue);
      }
      this.appService.createQmsTasksEC(this.ecData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleAddPopup.close();
            this.getcallMethod();
          }
          this.isProcessing = false;
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddPopup.close();
  }

  onFieldFocusout() {
    if (this.deleteReasonFieldValue != undefined) {
      if (this.ecData.deleteReason == "" || this.ecData.deleteReason == undefined) {
        this.deleteReasonFieldValue.style.color = 'red';
      } else {
        this.deleteReasonFieldValue.style.color = '';
      }
    }

    if (this.approvalCommentsFiledValue != undefined) {
      if (this.ecData.approvalComments == "" || this.ecData.approvalComments == undefined) {
        this.approvalCommentsFiledValue.style.color = 'red';
      } else {
        this.approvalCommentsFiledValue.style.color = '';
      }
    }

    if (this.conclusionValue != undefined) {
      if (this.ecData.conclusion == "" || this.ecData.conclusion == undefined) {
        this.conclusionValue.style.color = 'red';
      } else {
        this.conclusionValue.style.color = '';
      }
    }

    if (this.criteriaValue != undefined) {
      if (this.ecData.criteria == "" || this.ecData.criteria == undefined) {
        this.criteriaValue.style.color = 'red';
      } else {
        this.criteriaValue.style.color = '';
      }
    }
  }

  deleteQmsTasksEcId: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Effectiveness Check";
    if (deleteRowData.EC_ID != undefined || deleteRowData.EC_ID != null) {
      this.deleteQmsTasksEcId = deleteRowData.EC_ID;
    } else {
      this.deleteQmsTasksEcId = deleteRowData.ecId;
    }
    this.ecData.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteReasonFieldValue: any;
  deleteValidation() {
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteReasonFieldValue.style.color = 'red';
    } else {
      this.deleteReasonFieldValue.style.color = '';
    }
  }

  deleteFiledValue: any;
  deleteFunction(ecData: any) {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.ecData.deleteReason == '') {
      this.deleteValidation();
      alert('Please enter the mandatory fields...');
      this.isProcessing = false;
    } else {
      ecData.qmsTaskECVwPk = {
        ecId: this.deleteQmsTasksEcId
      };
      ecData.deleteReason = this.ecData.deleteReason;
      this.appService.deleteQmsTasksEC(ecData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleDeletePopup.close();
            this.visibleEcDetailsPopup.close();
            this.getcallMethod();
          }
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });

        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }


  //  * * * * * * * * * * * * * * * * EC Details Popup * * * * * * * * * * * * * * * *
  getEcDetails: any = [];
  filteredCheckRequiredForValue: any = [];
  filteredOutcomeValue: any = [];
  filteredOwnerValue: any = [];
  filteredMethodologyValue: any = [];
  buttonList: any;
  buttongetCall() {
    this.buttonList = [];
    let getbuttons = {
      qmsTaskECVwPk: {
        ecId: this.ecData.ecId,
      },
    }
    this.appService.getTaskEcButtons(getbuttons).subscribe((data: any) => {

      if (data.buttonValues != null) {
        this.buttonList = data.buttonValues.split(",");
      }
      console.log(this.buttonList);

    });
  }
  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  isEsignRequired: boolean;
  isReasonSignReqd: boolean;
  buttonLabel: any;
  reason: any;
  userName: any;
  password: any = "";
  confirmWithReasonPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  reviewStatus: any = [];
  selectedStatus: any = null;
  newEcData: any = {};
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  callfromDynamicButton: boolean = false;
  executeDynamicButtons(ecData: any, button: any) {
    this.callfromDynamicButton = true;
    if (button == "Save") {
      this.saveEcDetails(this.ecData, false);
    } else if (button == "Delete") {
      this.openDeletePopup(this.ecData);
    } else if (button == "Close" || button == "Closed") {
      if (this.selectedCheckRequiredFor == null || this.selectedOwner == null || this.ecData.dueDate == '' || this.ecData.dueDate == null || this.ecData.dueDate == undefined ||
        (this.selectedCheckRequiredForValueExp == "Over All" && (this.selectedMethodology == null || this.ecData.criteria == '' || this.ecData.criteria == null || this.ecData.criteria == undefined)) ||
        (this.showConclusion && (!this.ecData.conclusion || this.isContentEmpty(this.ecData.conclusion)))) {
        setTimeout(() => this.showSnackBar('Please enter the all mandatory fields...', 'E'));
        this.popupFieldsValidation();
      } else {
        this.saveEcDetails(this.ecData, this.callfromDynamicButton);
        this.showClosedStatusFields = true;
        this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
      }
    } else if (button == "Approve" || button == "QA Approve") {
      this.reviewStatus = ['Approved', 'Approval Rejected'];
      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    } else if (this.selectedCheckRequiredFor == null || this.selectedOwner == null || this.ecData.dueDate == '' || this.ecData.dueDate == null || this.ecData.dueDate == undefined ||
      (this.selectedCheckRequiredForValueExp == "Over All" && (this.selectedMethodology == null || this.ecData.criteria == '' || this.ecData.criteria == null || this.ecData.criteria == undefined)) ||
      (this.showConclusion && (this.ecData.conclusion == '' || this.ecData.conclusion == undefined || this.ecData.conclusion == null))) {
      setTimeout(() => this.showSnackBar('Please enter the all mandatory fields...', 'E'));
      this.isProcessing = false;
      this.popupFieldsValidation();
    } else {

      if (button == 'Submit for Approval') {
        this.selectedApprovedBy = null;
      }
      this.saveEcDetails(this.ecData, this.callfromDynamicButton);
      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    }
  }

  showClosedStatusFields: boolean = false;
  dynamicButtonClick(ecData: any, button: any) {
    this.isProcessing = true;
    this.userName = localStorage.getItem("loggedUserName");
    this.buttonLabel = button;
    [this.outcomeValue, this.ecData.closureComments, this.selectedStatus, this.reason, this.password] = [null, null, null, "", ""];
    [this.newEcData, this.selectedOutcome, this.selectedNewCheckRequiredFor, this.selectedNewOwner] = [{}, null, null, null];
    this.isReasonSignReqd = this.isEsignRequired = true;
    this.changetypeAddAndEditPassword = true;
    if (button == 'Submit for Approval') {
      if (this.selectedCheckRequiredForValueExp == "Individual Action Items") {
        this.appService.getQmsTaskEcActionVwDetails(this.message.activityId, this.message.ecMasterDetails.EC_ID).subscribe((data: any) => {
          if (data.length) {
            this.appService.getQmsTaskEcParticipantsVwDetailsByOrgIdAndRefNoAndEcId(this.message.activityId, this.message.ecMasterDetails.EC_ID).subscribe((data: any) => {
              if (data.length) {
                this.isProcessing = false;
                this.executeDynamicButtons(ecData, button);
              } else {
                this.isProcessing = false;
                this.showSnackBar('Please add EC Participants', 'E');
              }
            });
          } else {
            this.isProcessing = false;
            this.showSnackBar('Please add EC Actions', 'E');
          }
        });
      } else {
        this.appService.getQmsTaskEcParticipantsVwDetailsByOrgIdAndRefNoAndEcId(this.message.activityId, this.message.ecMasterDetails.EC_ID).subscribe((data: any) => {
          if (data.length) {
            this.isProcessing = false;
            this.executeDynamicButtons(ecData, button);
          } else {
            this.isProcessing = false;
            this.showSnackBar('Please add EC Participants', 'E');
          }
        });
      }
    } else if (button == 'Send to QA' || button == 'Re-Send to QA' || button == 'Close') {
      if (this.selectedCheckRequiredForValueExp == "Individual Action Items") {
        this.appService.getQmsTaskEcActionVwDetails(this.message.activityId, this.message.ecMasterDetails.EC_ID).subscribe((data: any) => {
          const incompleteActions = data.filter((action: any) => (!action.conclusion || this.isContentEmpty(action.conclusion)));

          if (incompleteActions.length > 0) {
            const actionNames = incompleteActions.map((a: any) => {
              const name = a.actionName?.trim() || 'Unnamed Action';
              return name.length > 50 ? name.slice(0, 50) + '...' : name;
            }).join('\n');
            const message = actionNames.length > 0 ? `Please add Conclusion for the Action(s): ${actionNames}` : 'Please add Conclusion for the Action(s)';
            this.showSnackBar(message, 'E');
            this.isProcessing = false;
          } else {
            this.isProcessing = false;
            this.executeDynamicButtons(ecData, button);
          }
        });
      } else if (this.selectedCheckRequiredForValueExp == "Individual Findings") {
        this.appService.getAllEcFindings(this.message.activityId, this.message.ecMasterDetails.EC_ID).subscribe((data: any) => {
          const incompleteFindings = data.filter((action: any) => (!action.conclusion || this.isContentEmpty(action.conclusion)));

          if (incompleteFindings.length > 0) {
            const findings = incompleteFindings.map((a: any) => {
              const name = a.finding?.trim() || 'Unnamed Finding';
              return name.length > 50 ? name.slice(0, 50) + '...' : name;
            }).join('\n');
            const message = findings.length > 0 ? `Please add Conclusion for the Finding(s): ${findings}` : 'Please add Conclusion for the Finding(s)';
            this.showSnackBar(message, 'E');
            this.isProcessing = false;
          } else {
            this.isProcessing = false;
            this.executeDynamicButtons(ecData, button);
          }
        });
      } else {
        this.isProcessing = false;
        this.executeDynamicButtons(ecData, button);
      }
    } else {
      this.isProcessing = false;
      this.executeDynamicButtons(ecData, button);
    }

    this.preventSnackBar = button == 'Submit for Approval' || button == 'Re-Submit for Approval' || button == 'Send to QA' || button == 'Re-Send to QA' || button == 'Close';
  }

  isContentEmpty(content: string): boolean {
    // Create a temporary element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Get the text content and trim it
    const textContent = tempDiv.textContent ?? tempDiv.innerText ?? '';
    return textContent.trim().length === 0;
  }

  deleteReasonValidation() {
    const reason = document.getElementById('reason') as HTMLInputElement;
    const reasonValidationIcon = document.getElementById('reason-val-icon') as HTMLInputElement;
    const reasonRequiredMsg = document.getElementById('reason-required-msg') as HTMLInputElement;

    if (this.reason == "" || this.reason == null || this.reason == undefined) {
      reasonValidationIcon.innerHTML = '<i class="fas fa-exclamation-circle"></i>';
      reasonValidationIcon.style.color = 'red';
      reason.style.border = '1px solid red';
      reasonRequiredMsg.style.display = 'block';
    } else {
      reasonValidationIcon.innerHTML = '';
      reasonValidationIcon.style.color = 'none';
      reason.style.border = 'none';
      reasonRequiredMsg.style.display = 'none';
    }
  }

  radioChange(event: any) {
    console.log(event.value);
    if (this.buttonLabelFieldValue != undefined) {
      this.buttonLabelFieldValue.style.color = '';
    }
  }

  buttonLabelFieldValue: any;
  passwordFieldValue: any;
  approveByFieldValue: any;
  qaApproveByFieldValue: any;
  outcomeFieldValue: any;
  closureCommentsFieldValue: any;
  checkRequiredForFieldValue: any;
  ownerFieldFieldValue: any;
  dueDateFieldValue: any;
  reasonFieldValue: any;

  buttonOperationFieldValidation() {
    this.buttonLabelFieldValue = document.getElementById('buttonLabel-validation') as HTMLInputElement;
    this.passwordFieldValue = document.getElementById('password-validation') as HTMLInputElement;
    this.approveByFieldValue = document.getElementById('approveBy-validation') as HTMLInputElement;
    this.qaApproveByFieldValue = document.getElementById('qaApproveBy-validation') as HTMLInputElement;
    this.outcomeFieldValue = document.getElementById('outcome-validation') as HTMLInputElement;
    this.closureCommentsFieldValue = document.getElementById('closureComments-validation') as HTMLInputElement;
    this.checkRequiredForFieldValue = document.getElementById('checkRequiredFor-validation') as HTMLInputElement;
    this.ownerFieldFieldValue = document.getElementById('ownerField-validation') as HTMLInputElement;
    this.dueDateFieldValue = document.getElementById('dueDate-validation') as HTMLInputElement;
    this.reasonFieldValue = document.getElementById('comments-validation') as HTMLInputElement;
    this.checkRequiredForFieldValue = document.getElementById('checkRequire-validation') as HTMLInputElement;
    this.ownerFieldFieldValue = document.getElementById('owner-validation') as HTMLInputElement;
    this.dueDateFieldValue = document.getElementById('due-validation') as HTMLInputElement;

    if (this.buttonLabel == 'QA Approve' || this.buttonLabel === 'Approve') {
      if (this.reason == '' || this.reason == undefined && (this.buttonLabel == "Approve" || this.buttonLabel == "QA Approve")) {
        this.buttonLabelFieldValue.style.color = 'red';
      } else {
        this.buttonLabelFieldValue.style.color = '';
      }
    }
    if (localStorage.getItem("adEnabled") != 'Y') {
      if (this.password) {
        this.passwordFieldValue.style.color = '';
      } else {
        this.passwordFieldValue.style.color = 'red';
      }
    }


    if (this.buttonLabel == 'Submit for Approval' || this.buttonLabel == 'Re-Submit for Approval') {
      if (this.selectedApprovedBy) {
        this.approveByFieldValue.style.color = '';
      } else {
        this.approveByFieldValue.style.color = 'red';
      }
    }

    if (this.buttonLabel == 'Send to QA' || this.buttonLabel == 'Re-Send to QA') {
      if (this.selectedQAApprovedBy) {
        this.qaApproveByFieldValue.style.color = '';
      } else {
        this.qaApproveByFieldValue.style.color = 'red';
      }
    }

    if (this.buttonLabel == 'Approve' || this.buttonLabel == 'QA Approve') {
      if (this.reason) {
        this.reasonFieldValue.style.color = '';
      } else {
        this.reasonFieldValue.style.color = 'red';
      }
    }

    if (this.buttonLabel == "Close" || this.ecData.status == 'Closed') {
      if (this.selectedOutcome) {
        this.outcomeFieldValue.style.color = '';
      } else {
        this.outcomeFieldValue.style.color = 'red';
      }

      if (this.ecData.closureComments) {
        this.closureCommentsFieldValue.style.color = '';
      } else {
        this.closureCommentsFieldValue.style.color = 'red';
      }
    }

    if (this.outcomeValue == 'Set New Check Date') {
      if (this.checkRequiredForFieldValue) {
        this.checkRequiredForFieldValue.style.color = (this.selectedNewCheckRequiredFor) ? '' : 'red';
      }

      if (this.ownerFieldFieldValue) {
        this.ownerFieldFieldValue.style.color = (this.selectedNewOwner) ? '' : 'red';
      }

      if (this.dueDateFieldValue) {
        this.dueDateFieldValue.style.color = (this.newEcData.dueDate) ? '' : 'red';
      }
    }

  }

  onButtonOperationFieldFocusout() {
    this.passwordFieldValue = document.getElementById('password-validation') as HTMLInputElement;
    this.reasonFieldValue = document.getElementById('comments-validation') as HTMLInputElement;

    if (this.passwordFieldValue != undefined) {
      if (this.password == null || this.password == undefined || this.password == '') {
        this.passwordFieldValue.style.color = 'red';
      } else {
        this.passwordFieldValue.style.color = '';
      }
    }

    if (this.buttonLabel == 'Approve' || this.buttonLabel == 'QA Approve') {
      if (this.reasonFieldValue != undefined) {
        if (this.reason == null || this.reason == undefined || this.reason == '') {
          this.reasonFieldValue.style.color = 'red';
        } else {
          this.reasonFieldValue.style.color = '';
        }
      }
    }

    if (this.buttonLabel == 'Close' || this.buttonLabel == 'Closed') {
      if (this.closureCommentsFieldValue != undefined) {
        if (this.ecData.closureComments == null || this.ecData.closureComments == undefined || this.ecData.closureComments == '') {
          this.closureCommentsFieldValue.style.color = 'red';
        } else {
          this.closureCommentsFieldValue.style.color = '';
        }
      }
    }
  }
  authEnable(flag: string) {

    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          console.log(result.account?.username);
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            console.log("inside");

            this.confirmWithReasonFuncOertaion();


          } else {
            console.log("outside");
          }

        },
        error: (error) => {
          this.isProcessing = false;
          console.log(error)

        }
      });
  }

  refreshTaskEcTabComponents: boolean = false;
  confirmWithReasonFunc() {
    this.isProcessing = true;
    if ((this.buttonLabel == "Submit for Approval" || this.buttonLabel == "Re-Submit for Approval") && (!this.selectedApprovedBy) ||
      (this.buttonLabel == "Send to QA" || this.buttonLabel == "Re-Send to QA") && (this.selectedQAApprovedBy == null) ||
      (this.buttonLabel == "Approve" || this.buttonLabel == "QA Approve") && (this.reason == '' || this.reason == undefined) ||
      (this.buttonLabel == "Close" || this.buttonLabel == "Closed") && (this.selectedOutcome == null || this.ecData.closureComments == '' || this.ecData.closureComments == undefined) ||
      (this.outcomeValue == "Set New Check Date") && (!this.selectedNewCheckRequiredFor || !this.selectedNewOwner || !this.newEcData.dueDate)) {
      this.buttonOperationFieldValidation();
      setTimeout(() => this.showSnackBar("Please enter mandatory fields..", 'E'));
      this.isProcessing = false;
    } else if (localStorage.getItem("adEnabled") == 'Y') {
      this.authEnable("adenabele")
    } else if (localStorage.getItem("adEnabled") != 'Y' && (this.password == "" || this.password == null)) {
      this.buttonOperationFieldValidation();
      setTimeout(() => this.showSnackBar("Please enter password", 'E'));
      this.isProcessing = false;
    } else {
      let data = {
        userName: this.userName,
        password: this.password,
      }
      this.isProcessing = true;
      this.appService.validateUser(data).subscribe((data: any) => {
        if (data.resultType == "S") {

          this.confirmWithReasonFuncOertaion();
        } else {
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
          this.isProcessing = false;
        }
      })
    }
  }
  confirmWithReasonFuncOertaion() {

    if (this.buttonLabel == "Mark Inprogress") {
      let ecData = this.ecData;
      this.isProcessing = true;
      ecData.qmsTaskECVwPk = {
        ecId: this.message.ecMasterDetails.EC_ID,
      }
      if (this.selectedCheckRequiredFor) {
        ecData.checkReqdFor = this.selectedCheckRequiredFor;
      } else {
        ecData.checkReqdFor = null;
      }
      if (this.selectedOwner) {
        ecData.owner = this.selectedOwner;
      } else {
        ecData.owner = null;
      }
      if (this.selectedMethodology) {
        ecData.methodology = this.selectedMethodology;
      } else {
        ecData.methodology = null;
      }
      if (this.selectedOutcome) {
        ecData.outcome = this.selectedOutcome;
      } else {
        ecData.outcome = null;
      }
      if (this.ecData.startDate) {
        const startDateValue = new Date(this.ecData.startDate);
        ecData.startDate = this.appService.dateZoneConvertion(startDateValue);
      } else {
        ecData.startDate = null;
      }
      if (this.ecData.dueDate) {
        const dueDateValue = new Date(this.ecData.dueDate);
        ecData.dueDate = this.appService.dateZoneConvertion(dueDateValue);
      } else {
        ecData.dueDate = null;
      }
      ecData.status = this.buttonLabel;
      this.appService.updateQmsTasksEC(ecData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleConfirmWithReason.close();
            this.buttongetCall();
            this.idCall();
            this.setAesthetic();
            this.refreshTaskEcTabComponents = true;
          }
          this.isProcessing = false;
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    } else if (this.buttonLabel == "Submit for Approval" || this.buttonLabel == "Re-Submit for Approval") {
      let data = {
        qmsTaskECVwPk: {
          ecId: this.ecData.ecId,
        },
        approvedBy: null,
      }
      if (this.selectedApprovedBy) {
        data.approvedBy = this.selectedApprovedBy
      }
      this.appService.setTaskEcForApproval(data).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.visibleConfirmWithReason.close();
          this.buttongetCall();
          this.idCall();
          this.setAesthetic();
          this.refreshTaskEcTabComponents = true;
        }
        this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          //duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        this.snackbarRef.onAction().subscribe(() => {
          this.snackbarRef.dismiss();
        });
        this.isProcessing = false;
      })
    } else if (this.buttonLabel == "Send to QA" || this.buttonLabel == 'Re-Send to QA') {
      let data = {
        qmsTaskECVwPk: {
          ecId: this.ecData.ecId,

        },
        approvedBy: null,
      }
      if (this.selectedQAApprovedBy) {
        data.approvedBy = this.selectedQAApprovedBy
      }
      this.appService.setTaskEcForQaApproval(data).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.visibleConfirmWithReason.close();
          this.buttongetCall();
          this.idCall();
          this.setAesthetic();
          this.refreshTaskEcTabComponents = true;
        }
        this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          //duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        this.snackbarRef.onAction().subscribe(() => {
          this.snackbarRef.dismiss();
        });
        this.isProcessing = false;
      })
    } else if (this.buttonLabel == "Approve" || this.buttonLabel == "QA Approve") {
      let selectedStatus = null;
      selectedStatus = this.selectedStatus
      let data = {
        qmsTaskECVwPk: {
          ecId: this.ecData.ecId,
        },
        approvalStatus: selectedStatus,
        approvalComments: this.reason,
      }
      if (this.buttonLabel == "Approve") {
        this.appService.approveTaskEc(data).subscribe((Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == "S") {
            this.visibleConfirmWithReason.close();
            this.buttongetCall();
            this.idCall();
            this.setAesthetic();
            this.refreshTaskEcTabComponents = true;
          }
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
          this.isProcessing = false;
        })
      } else if (this.buttonLabel == "QA Approve") {
        this.appService.qaApproveTaskEc(data).subscribe((Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == "S") {
            this.visibleConfirmWithReason.close();
            this.buttongetCall();
            this.idCall();
            this.setAesthetic();
            this.refreshTaskEcTabComponents = true;
          }
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
          this.isProcessing = false;
        })
      }

    } else if (this.buttonLabel == "Delete") {
      this.ecData.status = this.buttonLabel;
      this.deleteFunction(this.ecData);
    } else {
      this.ecData.status = this.buttonLabel;
      this.saveEcDetails(this.ecData, false);
    }
  }
  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  setnewEC() {
    this.isProcessing = true;
    this.newEcData.module = this.qualityService.moduleName;
    this.newEcData.refNo = this.message.activityId;
    this.newEcData.triggeredFromEcId = this.message.ecMasterDetails.EC_ID;
    if (this.selectedCheckRequiredFor) {
      this.newEcData.checkReqdFor = this.selectedCheckRequiredFor;
    } else {
      this.newEcData.checkReqdFor = null;
    }
    if (this.selectedNewOwner) {
      this.newEcData.owner = this.selectedNewOwner;
    } else {
      this.newEcData.owner = null;
    }
    if (this.newEcData.dueDate) {
      let dueDateValue = new Date(this.newEcData.dueDate);
      this.newEcData.dueDate = this.appService.dateZoneConvertion(dueDateValue);
    } else {
      this.newEcData.dueDate = null;
    }
    this.appService.createQmsTasksEC(this.newEcData).subscribe({
      next: (Response: any) => {
        this.displayMessage = Response.result;
        this.displayResultType = Response.resultType;
        if (this.displayResultType == 'S') {
          this.visibleConfirmWithReason.close();
          this.buttongetCall();
          this.idCall();
        }
        this.isProcessing = false;
        this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        this.snackbarRef.onAction().subscribe(() => {
          this.snackbarRef.dismiss();
        });
      }, error: (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      }
    });

  }

  setAesthetic() {
    this.refreshTaskEcTabComponents = false;
    setTimeout(() => {
      this.refreshTaskEcTabComponents = true;
    });

    const status: string = this.ecData.status;
    const isOwner = this.ecData.owner === +this.message.getUserId();
    this.isFrozen = true;
    this.eliteConclusion = false;

    if (status == 'Planning' || status == 'QA Approval Rejected' || status == 'Approval Rejected') this.isFrozen = !isOwner;
    else if (status == 'In Progress') this.eliteConclusion = isOwner;

    this.ecData.showSubTaskButtons = (status == 'In Progress' && isOwner) ? false : this.isFrozen;

  }


  onTabChangeCheckRequiredFor: any;
  isFrozen: boolean = false;
  eliteConclusion: boolean = false;/* Exclusive privilege to edit conclusion field only by owners */
  openEcDetailsPopup(data: any, id: number) {
    if (id != 0) return;

    this.ecData = {};
    this.isProcessing = true;
    this.message.ecMasterDetails = data;
    this.onTabChangeCheckRequiredFor = data.CHECK_REQD_FOR;
    this.selectedMethodology = null;
    this.selectedQAApprovedBy = null;
    if (this.snackbarRef) {
      this.snackbarRef.dismiss();
    }
    this.appService.getQmsTaskEcVwDetailsByOrgIdAndRefNoAndECId(this.message.activityId, this.message.ecMasterDetails.EC_ID).subscribe({
      next:
        (data: any) => {
          this.getEcDetails = data;
          this.ecData = this.getEcDetails;
          this.ecData.criteria = this.getEcDetails.criteria;
          this.setAesthetic();
          this.ecData.conclusion = this.getEcDetails.conclusion;
          this.ecData.ecId = this.getEcDetails.qmsTaskECVwPk.ecId;
          this.buttongetCall();
          if (this.ecData.startDate) {
            let startDateValue = new Date(this.ecData.startDate.split('T'));
            this.ecData.startDate = startDateValue;
          } else {
            this.ecData.startDate = null;
          }
          if (this.ecData.status == 'In Progress' && this.disableEcFields) {
            this.showConclusion = true;
          } else {
            this.showConclusion = false;
          }
          if (this.ecData.dueDate) {
            let dueDateValue = new Date(this.ecData.dueDate.split('T'));
            this.ecData.dueDate = dueDateValue;
          } else {
            this.ecData.dueDate = null;
          }
          if (this.ecData.approvedOn) {
            let dueDateValue = new Date(this.ecData.approvedOn.split('T'));
            this.ecData.approvedOn = dueDateValue;
          } else {
            this.ecData.approvedOn = null;
          }
          if (this.ecData.qaApprovedOn) {
            let dueDateValue = new Date(this.ecData.qaApprovedOn.split('T'));
            this.ecData.qaApprovedOn = dueDateValue;
          } else {
            this.ecData.qaApprovedOn = null;
          }
          if (this.ecData.checkReqdFor != null) {
            this.filteredCheckRequiredForValue = this.checkRequiredForListDropdown.filter((x: any) => x.valueExp === this.ecData.checkReqdFor);
            if (this.filteredCheckRequiredForValue.length > 0) {
              this.ischeckRequiredForOdd = null;
              let selectedCheckRequiredFor = [{
                valueExp: this.filteredCheckRequiredForValue[0].valueExp,
                displayExp: this.filteredCheckRequiredForValue[0].displayExp
              }];
              this.selectedCheckRequiredFor = this.filteredCheckRequiredForValue[0].valueExp;
              this.onCheckRequiredForSelect(this.event, selectedCheckRequiredFor[0]);
            } else {

              let selectedCheckRequiredFor = [{
                valueExp: this.ecData.checkReqdFor,
                displayExp: this.ecData.checkReqdFor
              }];
              this.checkRequiredForListDropdown.push({
                valueExp: this.ecData.checkReqdFor,
                displayExp: this.ecData.checkReqdFor
              });
              this.ischeckRequiredForOdd = this.selectedCheckRequiredFor = this.ecData.checkReqdFor;
              this.onCheckRequiredForSelect(this.event, selectedCheckRequiredFor[0]);
            }
          }
          if (this.ecData.methodology != null) {
            this.filteredMethodologyValue = this.methodologyListDropdown.filter((x: any) => x.valueExp === this.ecData.methodology);
            if (this.filteredMethodologyValue.length > 0) {
              this.selectedMethodology = this.filteredMethodologyValue[0].valueExp;
              this.ismethodologyOdd = null;
            } else {
              this.methodologyListDropdown.push({
                valueExp: this.ecData.methodology,
                displayExp: this.ecData.methodology,
              });
              this.ismethodologyOdd = this.selectedMethodology = this.ecData.methodology;
            }
          }

          if (this.ecData.owner != null) {
            this.filteredOwnerValue = this.ownerListDropdown.filter((x: any) => x.valueExp === this.ecData.owner)
            if (this.filteredOwnerValue.length > 0) {
              this.isownerOdd = null;
            } else {
              this.ownerListDropdown.push({
                valueExp: this.ecData.owner,
                displayExp: this.ecData.ownerName,
              });
              this.isownerOdd = this.ecData.owner;
            }
            this.selectedOwner = this.ecData.owner;
          }

          if (this.ecData.outcome != null) {
            this.filteredOutcomeValue = this.outcomeListDropdown.filter((x: any) => x.valueExp === this.ecData.outcome);
            if (this.filteredOutcomeValue.length > 0) { /* empty */ } else {
              this.outcomeListDropdown.push({
                valueExp: this.ecData.outcome,
                displayExp: this.ecData.outcome,
              });
            }
            this.selectedOutcome = this.ecData.outcome;
          }

          if (this.ecData.approvedBy) {
            const matchingApprover = this.approvedByListDropdown.find((x: any) => x.valueExp === this.ecData.approvedBy)
            if (matchingApprover) {
              // this.selectedApprovedBy = [{
              //   valueExp: matchingApprover.userId,
              //   displayExp: matchingApprover.userName
              // }]
              this.isapprovedByOdd = null;
            } else {
              this.approvedByListDropdown.push({
                valueExp: this.ecData.approvedBy,
                displayExp: this.ecData.approver,
              });
              this.isapprovedByOdd = this.ecData.approvedBy;
            }
            this.selectedApprovedBy = this.ecData.approvedBy;
          }

          if (this.ecData.qaApprovedBy) {
            const matchingQAApprover = this.QAapprovedByListDropdown.find((x: any) => x.valueExp === this.ecData.qaApprovedBy)
            if (matchingQAApprover) {
              // this.selectedQAApprovedBy = [{
              //   valueExp: matchingQAApprover.userId,
              //   displayExp: matchingQAApprover.userName
              // }]
              this.isQaapprovedByOdd = null;
            } else {
              this.QAapprovedByListDropdown = [{
                valueExp: this.ecData.qaApprovedBy,
                displayExp: this.ecData.qaApprover,
              }];
              this.isQaapprovedByOdd = this.ecData.qaApprovedBy;
            }
            this.selectedQAApprovedBy = this.ecData.qaApprovedBy;
          }
          this.isProcessing = false;
          this.popupDataTitle.title = "Effectiveness Check";
          this.visibleEcDetailsPopup = this.dialog.open(this.ecDetailsPopup, this.ecDetailsPopupConfig);
        }, error:
        (error) => {
          this.isProcessing = false;
          throw error;
        }
    }
    );
  }

  idCall() {
    this.appService.getQmsTaskEcVwDetailsByOrgIdAndRefNoAndECId(this.message.activityId, this.message.ecMasterDetails.EC_ID).subscribe({
      next:
        (data: any) => {
          this.getEcDetails = data;
          this.ecData = this.getEcDetails;
          this.setAesthetic();
          this.ecData.criteria = this.getEcDetails.criteria;
          this.ecData.conclusion = this.getEcDetails.conclusion;
          this.ecData.ecId = this.getEcDetails.qmsTaskECVwPk.ecId;
          if (this.ecData.startDate) {
            let startDateValue = new Date(this.ecData.startDate.split('T'));
            this.ecData.startDate = startDateValue;
          } else {
            this.ecData.startDate = null;
          }

          if (this.ecData.status == 'In Progress' && this.disableEcFields) {
            this.showConclusion = true;
          } else {
            this.showConclusion = false;
          }

          if (this.ecData.dueDate) {
            let dueDateValue = new Date(this.ecData.dueDate.split('T'));
            this.ecData.dueDate = dueDateValue;
          } else {
            this.ecData.dueDate = null;
          }

          if (this.ecData.approvedOn) {
            let approvedOnValue = new Date(this.ecData.approvedOn.split('T'));
            this.ecData.approvedOn = approvedOnValue;
          } else {
            this.ecData.approvedOn = null;
          }

          if (this.ecData.qaApprovedOn) {
            let qaApprovedOnValue = new Date(this.ecData.qaApprovedOn.split('T'));
            this.ecData.qaApprovedOn = qaApprovedOnValue;
          } else {
            this.ecData.qaApprovedOn = null;
          }

          if (this.ecData.checkReqdFor != null) {
            this.filteredCheckRequiredForValue = this.checkRequiredForListDropdown.filter((x: any) => x.valueExp === this.ecData.checkReqdFor);
            if (this.filteredCheckRequiredForValue.length > 0) {
              let selectedCheckRequiredFor = [{
                valueExp: this.filteredCheckRequiredForValue[0].valueExp,
                displayExp: this.filteredCheckRequiredForValue[0].displayExp
              }];
              this.onCheckRequiredForSelect(this.event, selectedCheckRequiredFor[0]);
            } else {
              let selectedCheckRequiredFor = [{
                valueExp: this.ecData.checkReqdFor,
                displayExp: this.ecData.checkReqdFor
              }];
              this.checkRequiredForListDropdown.push({
                valueExp: this.ecData.checkReqdFor,
                displayExp: this.ecData.checkReqdFor
              });
              this.selectedCheckRequiredFor = this.ecData.checkReqdFor;
              this.onCheckRequiredForSelect(this.event, selectedCheckRequiredFor[0]);
            }
          }
          if (this.ecData.methodology != null) {
            this.filteredMethodologyValue = this.methodologyListDropdown.filter((x: any) => x.valueExp === this.ecData.methodology);
            if (this.filteredMethodologyValue.length > 0) { /* empty */ } else {
              this.methodologyListDropdown.push({
                valueExp: this.ecData.methodology,
                displayExp: this.ecData.methodology,
              });
              this.selectedCheckRequiredFor = this.ecData.methodology;
            }
          }
          if (this.ecData.owner != null) {
            this.filteredOwnerValue = this.ownerListDropdown.filter((x: any) => x.valueExp === this.ecData.owner)
            if (this.filteredOwnerValue.length > 0) {
              // this.selectedOwner = [{
              //   valueExp: this.filteredOwnerValue[0].userId,
              //   displayExp: this.filteredOwnerValue[0].userName
              // }]
            } else {
              this.dropDownForOwner.push({
                valueExp: this.ecData.owner,
                displayExp: this.ecData.ownerName
              });
            }
            this.selectedOwner = this.ecData.owner;
          }
          if (this.ecData.outcome != null) {
            this.filteredOutcomeValue = this.outcomeListDropdown.filter((x: any) => x.valueExp === this.ecData.outcome);
            if (this.filteredOutcomeValue.length > 0) { /* empty */ } else {
              this.outcomeListDropdown.push({
                valueExp: this.ecData.outcome,
                displayExp: this.ecData.outcome
              });
            }
            this.selectedOutcome = this.ecData.outcome;
          }

          if (this.ecData.approvedBy) {
            const matchingApprover = this.dropDownDataForApprovedBy.find((x: any) => x.userId === this.ecData.approvedBy)
            if (matchingApprover) {
              // this.selectedApprovedBy = [{
              //   valueExp: matchingApprover.userId,
              //   displayExp: matchingApprover.userName
              // }]
            } else {
              this.dropDownDataForApprovedBy.push({
                valueExp: this.ecData.approvedBy,
                displayExp: this.ecData.approver,
              });
            }
            this.selectedApprovedBy = this.ecData.approvedBy;
          }

          if (this.ecData.qaApprovedBy) {
            const matchingQAApprover = this.dropDownDataForQAApprovedBy.find((x: any) => x.userId === this.ecData.qaApprovedBy)
            if (matchingQAApprover) {
              // this.selectedQAApprovedBy = [{
              //   valueExp: matchingQAApprover.userId,
              //   displayExp: matchingQAApprover.userName
              // }]
            } else {
              this.dropDownDataForApprovedBy.push({
                valueExp: this.ecData.qaApprovedBy,
                displayExp: this.ecData.qaApprover,
              });
            }
            this.selectedQAApprovedBy = this.ecData.qaApprovedBy;
          }
          this.isProcessing = false;
          this.popupDataTitle.title = "Effectiveness Check";
        }, error:
        (error) => {
          console.log(error);
          this.isProcessing = false;
        }
    }
    );
  }
  cancelDetailPopup() {
    this.visibleEcDetailsPopup.close();
  }

  outcomeValue: any;
  outcomeRequiredMsg: any;
  methodologyValue: any;
  criteriaValue: any;
  conclusionValue: any;
  approvalCommentsFiledValue: any;


  popupFieldsValidation() {
    this.checkRequiredForRequiredMsg = document.getElementById('checkRequiredFor-validation') as HTMLInputElement;
    this.ownerFieldRequiredMsg = document.getElementById('ownerField-validation') as HTMLInputElement;
    this.outcomeRequiredMsg = document.getElementById('outcome-validation') as HTMLInputElement;
    this.dueDateFieldValue = document.getElementById("dueDate-validation") as HTMLInputElement;
    this.methodologyValue = document.getElementById("methodology-validation") as HTMLInputElement;
    this.criteriaValue = document.getElementById("criteria-validation") as HTMLInputElement;
    this.conclusionValue = document.getElementById("conclusion-validation") as HTMLInputElement;
    this.approvalCommentsFiledValue = document.getElementById("approvalComments-validation") as HTMLInputElement;

    if (this.selectedCheckRequiredFor == null) {
      this.checkRequiredForRequiredMsg.style.color = 'red';
    } else {
      this.checkRequiredForRequiredMsg.style.color = '';
    }

    if (this.selectedOwner == null) {
      this.ownerFieldRequiredMsg.style.color = 'red';
    } else {
      this.ownerFieldRequiredMsg.style.color = '';
    }

    if (this.ecData.dueDate == '' || this.ecData.dueDate == null || this.ecData.dueDate == undefined) {
      this.dueDateFieldValue.style.color = 'red';
    } else {
      this.dueDateFieldValue.style.color = '';
    }

    if (this.ecData.approvalComments != null) {
      if (this.ecData.approvalComments == '' || this.ecData.approvalComments == null || this.ecData.approvalComments == undefined) {
        this.approvalCommentsFiledValue.style.color = 'red';
      } else {
        this.approvalCommentsFiledValue.style.color = '';
      }
    }

    if (this.selectedCheckRequiredForValueExp == "Over All") {
      if (this.selectedMethodology == null) {
        this.methodologyValue.style.color = 'red';
      } else {
        this.methodologyValue.style.color = '';
      }

      if ((this.selectedCheckRequiredForValueExp == 'Over All' || this.ecData.status == 'In Progress' || this.ecData.status == 'Planning') && (this.ecData.criteria == '' || this.ecData.criteria == null)) {
        this.criteriaValue.style.color = 'red';
      } else {
        this.criteriaValue.style.color = '';
      }
    }

    if (this.showConclusion) {
      if (this.ecData.conclusion == "" || this.ecData.conclusion == null || this.ecData.conclusion == undefined) {
        this.conclusionValue.style.color = 'red';
      } else {
        this.conclusionValue.style.color = '';
      }
    }

  }

  preventSnackBar: boolean = false;
  saveEcDetails(ecData: any, callfromDynamicButton: boolean) {
    if (!this.skipValidationsWhileSwitchingUser && (this.selectedCheckRequiredFor == null || this.selectedOwner == null || this.ecData.dueDate == '' || this.ecData.dueDate == null || this.ecData.dueDate == undefined ||
      (this.selectedCheckRequiredForValueExp == "Over All" && (this.selectedMethodology == null || this.ecData.criteria == '' || this.ecData.criteria == null || this.ecData.criteria == undefined)) ||
      (this.showConclusion && (!this.ecData.conclusion || this.isContentEmpty(this.ecData.conclusion))))) {
      alert("Please enter the all mandatory fields...");
      this.popupFieldsValidation();
    } else {
      this.isProcessing = true;
      ecData.qmsTaskECVwPk = {
        ecId: this.message.ecMasterDetails.EC_ID,
      }
      if (this.selectedCheckRequiredFor) {
        ecData.checkReqdFor = this.selectedCheckRequiredFor;
      } else {
        ecData.checkReqdFor = null;
      }
      if (this.selectedOwner) {
        ecData.owner = this.selectedOwner;
      } else {
        ecData.owner = null;
      }
      if (this.selectedMethodology) {
        ecData.methodology = this.selectedMethodology;
      } else {
        ecData.methodology = null;
      }
      if (this.selectedOutcome) {
        ecData.outcome = this.selectedOutcome;
      } else {
        ecData.outcome = null;
      }
      if (this.ecData.startDate) {
        const startDateValue = new Date(this.ecData.startDate);
        ecData.startDate = this.appService.dateZoneConvertion(startDateValue);
      } else {
        ecData.startDate = null;
      }
      if (this.ecData.dueDate) {
        const dueDateValue = new Date(this.ecData.dueDate);
        ecData.dueDate = this.appService.dateZoneConvertion(dueDateValue);
      } else {
        ecData.dueDate = null;
      }
      if (this.ecData.approvedOn) {
        ecData.approvedOn = new Date(this.ecData.approvedOn);
      } else {
        ecData.approvedOn = null;
      }

      if (this.ecData.qaApprovedOn) {
        ecData.qaApprovedOn = new Date(this.ecData.qaApprovedOn);
      } else {
        ecData.qaApprovedOn = null;
      }
      ecData.approvedBy = this.selectedApprovedBy;
      ecData.qaApprovedBy = this.selectedQAApprovedBy;
      this.appService.updateQmsTasksEC(ecData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          this.setAesthetic();
          if (this.displayResultType == 'S') {
            this.skipValidationsWhileSwitchingUser && (this.skipValidationsWhileSwitchingUser = false);
            if (this.outcomeValue == 'Set New Check Date') {
              this.setnewEC();
              this.visibleConfirmWithReason.close();
            } else if (this.popupDataTitle.title == 'Create Effectiveness Check') {
              this.getcallMethod();
              this.buttongetCall();
              this.visibleConfirmWithReason.close();
            } else if (this.buttonLabel == 'Close' || this.buttonLabel == 'Closed') {

              this.appService.getQmsTaskEcVwDetailsByOrgIdAndRefNoAndECId(this.message.activityId, this.message.ecMasterDetails.EC_ID).subscribe((data: any) => {
                if (data?.status == 'Closed') {
                  this.visibleConfirmWithReason.close();
                  this.showClosedStatusFields = false;
                  this.ecData.status = data.status;
                  this.setAesthetic();
                  this.buttongetCall();
                  this.isProcessing = false;
                }
              })

            } else if (this.popupDataTitle.title == 'Effectiveness Check') {
              this.buttongetCall();
            }

          }
          this.isProcessing = false;

          if (!callfromDynamicButton) {
            this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: this.displayResultType == 'S' ? 6000 : undefined,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            this.snackbarRef.onAction().subscribe(() => {
              this.snackbarRef.dismiss();
            });
          }
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  selectedTab: string;
  selectedTabIndex: any;
  getQmsTaskECActionsVwDetails: any
  onTabChanged($event: any) {
    if ($event.tab) {
      this.selectedTab = $event.tab.textLabel;
    } else {
      this.selectedTab = $event;
    }

    if (this.onTabChangeCheckRequiredFor == "Individual Action Items" && (this.selectedTab != "Actions")) {
      this.isProcessing = true;
      this.appService.getQmsTaskEcActionVwDetails(this.message.activityId, this.message.ecMasterDetails.EC_ID).subscribe((data: any) => {
        this.getQmsTaskECActionsVwDetails = data;
        if (this.getQmsTaskECActionsVwDetails.length < 1) {
          this.selectedTabIndex = 0;
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: undefined,
            data: {
              message: "Please add Effectiveness Check Action",
              type: 'Sorry !',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
        }
        this.isProcessing = false;
      });
    } else if (this.onTabChangeCheckRequiredFor == "Individual Action Items" && (this.selectedTab == "Actions")) {
      this.isProcessing = true;
      this.appService.getQmsTaskEcActionVwDetails(this.message.activityId, this.message.ecMasterDetails.EC_ID).subscribe((data: any) => {
        this.getQmsTaskECActionsVwDetails = data;
        if (this.getQmsTaskECActionsVwDetails.length < 1) {
          this.selectedTabIndex = 0;
        }
        this.refreshTaskEcTabComponents = true;
        this.isProcessing = false;
      });
    } else if (this.onTabChangeCheckRequiredFor == "Individual Findings" && (this.selectedTab != "Findings")) {
      this.isProcessing = true;
      this.appService.getAllEcFindings(this.qualityService.activityId, this.message.ecMasterDetails.EC_ID).subscribe((findings: any) => {
        this.isProcessing = false;
        if (!findings.length) {
          this.selectedTabIndex = 0;
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: undefined,
            data: {
              message: "Please add Effectiveness Check Finding",
              type: 'Sorry !',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
        }
      })
    } else if (this.onTabChangeCheckRequiredFor == "Individual Findings" && (this.selectedTab == "Findings")) {
      this.isProcessing = true;
      this.appService.getAllEcFindings(this.qualityService.activityId, this.message.ecMasterDetails.EC_ID).subscribe((data: any) => {
        const findings: any[] = data;
        if (findings.length < 1) {
          this.selectedTabIndex = 0;
        }
        this.refreshTaskEcTabComponents = true;
        this.isProcessing = false;
      });
    } else if (this.onTabChangeCheckRequiredFor == "Individual Preliminary Actions" && (this.selectedTab != "Preliminary Actions")) {
      this.isProcessing = true;
      this.appService.getAllPreActionByRefNo(this.qualityService.activityId).subscribe((preActions: any) => {
        this.isProcessing = false;
        if (!preActions.length) {
          this.selectedTabIndex = 0;
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: undefined,
            data: {
              message: "Please add Preliminary Actions",
              type: 'Sorry !',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
        }
      })
    } else if (this.onTabChangeCheckRequiredFor == "Individual Preliminary Actions" && (this.selectedTab == "Preliminary Actions")) {
      this.isProcessing = true;
      this.appService.getAllPreActionByRefNo(this.qualityService.activityId).subscribe((data: any) => {
        const preActions: any[] = data;
        if (preActions.length < 1) {
          this.selectedTabIndex = 0;
        }
        this.refreshTaskEcTabComponents = true;
        this.isProcessing = false;
      });
    }
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  @ViewChild(SwitchuserComponent) switchUserComponent!: SwitchuserComponent;
  openSwitchUser(value: any) {
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = "EC";
    this.message.switchuserRole = value;
    if (value == "EC Owner") {
      this.message.switchedUser = this.selectedOwner;
      this.message.switchUserCurrentValue = this.selectedOwner;
      this.qualityService.ecDropdowns.selectedOwner = this.selectedOwner;
      this.message.switchUserdropDownList = this.ownerListDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) || []
    } else if (value == 'EC Approver') {
      this.message.switchedUser = this.selectedApprovedBy;
      this.message.switchUserCurrentValue = this.selectedApprovedBy;
      this.qualityService.ecDropdowns.selectedApprover = this.selectedApprovedBy;
      this.message.switchUserdropDownList = this.approvedByListDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) || []
    } else if (value == 'EC QA Approver') {
      this.message.switchedUser = this.selectedQAApprovedBy;
      this.message.switchUserCurrentValue = this.selectedQAApprovedBy;
      this.qualityService.ecDropdowns.selectedQAApprover = this.selectedQAApprovedBy;
      this.message.switchUserdropDownList = this.QAapprovedByListDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) || []
    }
    this.switchUserComponent.openswitchuser(value, 'EC');
  };
  skipValidationsWhileSwitchingUser: boolean = false;
  onChildValueEmitted() {
    this.skipValidationsWhileSwitchingUser = true;
    if (this.message.switchuserRole == "EC Owner") {
      this.selectedOwner = this.message.switchedUser;
    } else if (this.message.switchuserRole == "EC Approver") {
      this.selectedApprovedBy = this.message.switchedUser;
    } else if (this.message.switchuserRole == "EC QA Approver") {
      this.selectedQAApprovedBy = this.message.switchedUser;
    }
    this.switchUserComponent.saveMethod();
    this.switchUserComponent.cancelSwitchUserPopup();
    this.switchUserComponent.closeConfirmationPopup();
    this.dynamicButtonClick(null, "Save");
  }

  idMapping: Record<string, string> = { 'CR': this?.qualityService?.activity?.crId, 'CAPA': this.qualityService.activity.capaId, 'DV': this.qualityService.activity.dvId, 'AU': this.qualityService.activity.auId, 'IN': this.qualityService.activity.inId, 'QI': this.qualityService.activity.qiId, 'CC': this.qualityService.activity.ccId };

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, ec: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : ec.EC_ID;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'EC';
    this.auditTrail.report_And_Popup_Name = this.qualityService.moduleName + ' Effectiveness Check Audit Trail [' + this.idMapping[this.qualityService.moduleName] + ']';
    this.dynamicAuditTrailComponent.triggerTrail(ec);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qualityService.moduleName + ' Effectiveness Check Report [' + this.idMapping[this.qualityService.moduleName] + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, this.module, 0)
  }

  onChildValueEmit() {
    this.getcallMethod();
  };

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  editorTitle: any;
  allowEditing: boolean = false;
  openEditor(value: string, icon: string) {
    value == 'Deviation Description' && (value = 'DV Description');
    this.editorTitle = value;
    value == 'Effectiveness Check and Conclusion' && (value = 'Conclusion');
    this.allowEditing = icon == 'edit';

    const formattedValue = value
      .split(' ')
      .map((word, index) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');

    this.editorValue = (value == 'Criteria' || value == 'Conclusion' || value == 'QA Approval Comments' || value == 'Approval Comments') ? this.ecData[formattedValue] : this.qualityService.activity[formattedValue];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }
  saveEditor(editorValue: any) {
    if (this.editorTitle == 'Effectiveness Check and Conclusion') {
      this.editorTitle = 'Conclusion';
    }

    const formattedTitle = this.editorTitle
      .split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');


    if (this.editorTitle == 'Criteria' || this.editorTitle == 'Conclusion' || this.editorTitle == 'QA Approval Comments' || this.editorTitle == 'Approval Comments') {
      this.ecData[formattedTitle] = editorValue;
    } else {
      this.qualityService.activity[formattedTitle] = editorValue;
    }


    this.visibleEditor.close();
  }


  cancelEditor() {
    this.visibleEditor.close();
  }

  getTabLabel(): string {
    if (this.selectedCheckRequiredForValueExp == 'Individual Action Items') {
      return 'Actions';
    } else if (this.selectedCheckRequiredForValueExp == 'Individual Preliminary Actions') {
      return 'Preliminary Actions';
    } else {
      return 'Findings';
    }
  }

  public focusEmpty(): void { console.log(); }

}
